export default {"src":"/_next/static/media/404.05e8ecaa.svg","height":134,"width":240,"blurWidth":0,"blurHeight":0};